import { CustomerLiteModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestLiteModel } from 'api-hooks/guest';
import { SaleLiteModel, SaleModel } from 'api-hooks/sale/common';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class ProductSaleGuestModel extends CommonModel {
  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class ProductVariantModel {
  id: string;
  description: string;
  name: string;

  @Expose({ name: 'average_price' })
  averagePrice: string;

  @Expose({ name: 'sell_price' })
  sellPrice: string;

  @Type(() => Number)
  stock: number;
}

export class ProductSaleModel extends CommonModel {
  description: string;
  status: string;

  @Type(() => Number)
  price: number;

  @Type(() => Number)
  qty: number;

  @Expose({ name: 'complete_name' })
  completeName: string;

  @Expose({ name: 'product_variant' })
  @Type(() => ProductVariantModel)
  productVariant: ProductVariantModel;
}

export class ProductSalesModel extends SaleModel {
  @Expose({ name: 'product_sales' })
  @Type(() => ProductSaleModel)
  productSales: ProductSaleModel[];
}

export class BillingAddressLiteModel {
  id: string;
  address: string;
  phone: string;
}

export class ProductSaleLiteModel extends SaleLiteModel {
  id: string;
  guests: string[];
  code: string;

  @Expose({ name: 'booking_codes' })
  bookingCodes: string[];

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => EmployeeLiteModel)
  admin: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel | null;

  @Type(() => EmployeeLiteModel)
  salesman: EmployeeLiteModel | null;

  @Expose({ name: 'payment_status' })
  paymentStatus: string;
}
//query
export type getProductsSaleInput = {
  params: CommonParamInput;
};

export type getProductSaleInput = {
  id: string;
};

//mutation
export type ProductSaleMutationInput = {
  refId?: string;
  transactionAt: Date;
  needApproval: boolean;
  code: string;
  description: string;
  adminId: string;
  operatorId: string;
  salesmanId: string;
  customerId: string;
  customerBillingId: string;
  discount: number;
  otherCost: number;
  total: number;

  productSales: {
    productVariantId: string;
    price: number;
    qty: number;
    description: string;
  }[];
};

export type ProductSaleMutationUpdateInput = {
  id: string;
  body: ProductSaleMutationInput;
};

export type ProductSaleMutationVoidInput = {
  id: string;
};

export type ProductSaleMutationCompleteInput = {
  id: string;
};
